export const calculateTrip = (tempRow) => {
    const { qty: m, tripRate: rate } = tempRow;
    const qty = m ?? 0;
    const tripRate = rate ?? 0;
    return qty * tripRate;
};
